import {computed, defineComponent, type PropType, ref, watch} from 'vue';
import {AnnouncementDto, type OperationsActorServiceInfo} from "@/api/enterprise-gateway-api.proxy.ts";
import * as yup from "yup";
import {useForm} from "vee-validate";
import {useOrganisationStore} from "@/app/stores/organisation-store.ts";
import {storeToRefs} from "pinia";
import {useModalEventsUtil} from "@/app/shared/helpers/modal-events-util.ts";
import DateUtil from "@/app/shared/helpers/date-util.ts";

export default defineComponent({
    name: 'AegAnnouncements',
    props: {
        announcements: {
            type: Object as PropType<AnnouncementDto[]>,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
            default: false
        },
    },
    emits: ['on-click'],
    setup: function (props, {emit}) {
        const announcementList = ref<AnnouncementDto[]>([]);
        const loading = ref<boolean>(false);
        const emptyState = ref<boolean>(false);
        const announcementsChanged = (newAnnouncements: AnnouncementDto[]) => {
            announcementList.value = newAnnouncements;
            emptyState.value = newAnnouncements.length === 0;
        }
        
        const formatDate = (announcement:  AnnouncementDto) => {
            if (!!announcement.to) {
                return `${DateUtil.formatDate(announcement.from)} tot en met ${DateUtil.formatDate(announcement.to)}`;
            } else {
                return DateUtil.formatDate(announcement.from);
            }
        }

        const gotoAnnouncement = (announcementId: string) => {
            emit('on-click', announcementId);
        }
        
        watch(() => props.announcements, announcementsChanged, {immediate: true, deep: true});
        watch(() => props.isLoading, (newValue) => { loading.value = newValue }, {immediate: true, deep: true});

        return {
            announcementList,
            loading,
            emptyState,
            formatDate,
            gotoAnnouncement
        }
    }
});
